











import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class FlatButtonWithIcon extends Vue {
    @Prop({ default: '' }) public label!: string;
    @Prop({ default: false }) public ripple!: boolean;
}
